import * as kreq from "kreq";

export const Version = '2016-03-04';
export const Service = 'kec';
export const source = 'kec'
export const url = '/kecapi/'


export const req = new kreq.ApiRequestFactory({
    // baseURL: '/kecapi/'
});
